module.exports = __webpack_public_path__ + "img/edit-white.e845af1c.svg";